function lsTutorialApp () {
  var idVal;
  var listId;
  var listIdNum = 1;
  var activeDot;
  var activePhoto;
  var dotId;
  var dotPhoto;
  var activeStep;
  var activePhotoId;
  var length;
   
  document.addEventListener('click', (e) => {
    console.log('Clicked:', e.target);
console.log('ClassName:', e.target.className);
console.log('ClassList:', e.target.classList);
console.log('Closest li:', e.target.closest('li'));
  	if (
      e.target.classList.contains('article_thumbnail')
      || e.target.parentNode.classList.contains('article_thumbnail')
      || e.target.parentNode.parentNode.classList.contains('article_thumbnail')
      || e.target.parentNode.parentNode.parentNode.classList.contains('article_thumbnail')
    ) {
      idVal = e.target.closest('.article_thumbnail').id.split('_')[1];
      document.querySelector('#' + idVal).className = 'tutorial_popup';
      document.querySelector('#' + idVal + ' #photo-step-1').className = 'step-photo active';
      document.querySelector('#' + idVal + ' #step-index-1').className = 'index-dot active';
      if ($(window).width() <= 768) {
        let stepList = document.querySelectorAll('#' + idVal + ' .step-list');
        for (let i = 0; i < stepList.length; i++) {
          stepList[i].className = 'step-list hidden';
        }
        document.querySelector('#' + idVal + ' #step-1').className = 'step-list active';
      }
    } else if (e.target.classList.contains('popup_overlay_background')) {
      document.querySelector('#' + idVal).className = 'hidden tutorial_popup';
      document.querySelector('#' + idVal + ' .step-photo.active').className = 'step-photo hidden';
      document.querySelector('#' + idVal + ' .index-dot.active').className = 'index-dot';
    } else if (e.target.classList.contains('close_popup')
                || e.target.parentNode.classList.contains('close_popup')
                || e.target.parentNode.parentNode.classList.contains('close_popup')
                || e.target.parentNode.parentNode.parentNode.classList.contains('close_popup')
              ) {
      document.querySelector('#' + idVal).className = 'hidden tutorial_popup';
      document.querySelector('#' + idVal + ' .step-photo.active').className = 'step-photo hidden';
      document.querySelector('#' + idVal + ' .index-dot.active').className = 'index-dot';
    } else if (e.target.classList.contains('step-list') || e.target.classList.contains('step-title') || e.target.classList.contains('step-desc')) {
      if ($(window).width() > 768) {
      	listId = e.target.closest('.step-list').id;
        listId = 'photo-' + listId;
        listIdNum = e.target.parentNode.id.split('-')[1];
        document.querySelector('#' + idVal + ' .step-photo.active').className = 'step-photo hidden';
        document.querySelector('#' + idVal + ' .index-dot.active').className = 'index-dot';
        document.querySelector('#' + idVal + ' #' + listId).className = 'step-photo active';
        document.querySelector('#' + idVal + ' #step-index-' + listIdNum).className = 'index-dot active';
      }
    } else if (e.target.className.includes('index-dot')) {
      if ($(window).width() > 768) {
      	dotId = e.target.id.split('-')[2];
        dotPhoto = document.querySelector('#' + idVal + ' #photo-step-' + dotId);
        document.querySelector('#' + idVal + ' .index-dot.active').className = 'index-dot';
        document.querySelector('#' + idVal + ' #step-index-' + dotId).className = 'index-dot active';
        document.querySelector('#' + idVal + ' .step-photo.active').className = 'step-photo hidden';
        document.querySelector('#' + idVal + ' #' + dotPhoto.id).className = 'step-photo active';
      }    
    } else if (e.target.classList.contains('step-prev') || e.target.classList.contains('step-nav-prev')) {
        activePhoto = document.querySelector('#' + idVal + ' .step-photo.active').id;
        activePhotoId = activePhoto.split('-')[2];
        length = document.querySelector('#' + idVal + ' .step-slides').children.length;
        if (activePhoto === 'photo-step-1'){
          	document.querySelector(`#${idVal} #photo-step-${length}`).className = 'step-photo active';
        	document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).className = 'index-dot';
        	document.querySelector('#' + idVal + ' #' + activePhoto).className = 'step-photo hidden';
          	document.querySelector(`#${idVal} #step-index-${length}`).className = 'index-dot active';
        } else if (document.querySelector('#' + idVal + ' #' + activePhoto).previousElementSibling.tagName === 'LI'){
          	document.querySelector('#' + idVal + ' #' + activePhoto).previousElementSibling.className = 'step-photo active';
        	document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).className = 'index-dot';
        	document.querySelector('#' + idVal + ' #' + activePhoto).className = 'step-photo hidden';
        	document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).previousElementSibling.className = 'index-dot active';
        }
        if ($(window).width() <= 768) {
        	activeStep = document.querySelector('#' + idVal + ' .step-list.active').id;
            if (activeStep === 'step-1'){
          		document.querySelector(`#${idVal} #step-${length}`).className = 'step-list active';
        		document.querySelector('#' + idVal + ' #' + activeStep).className = 'step-list hidden';
              
            } else if (document.querySelector('#' + idVal + ' #' + activeStep).previousElementSibling.tagName === 'LI'){
          		document.querySelector('#' + idVal + ' #' + activeStep).previousElementSibling.className = 'step-list active';
        		document.querySelector('#' + idVal + ' #' + activeStep).className = 'step-list hidden'
            }
        }
    } else if (e.target.classList.contains('step-next') || e.target.classList.contains('step-nav-next')) {
        activePhoto = document.querySelector('#' + idVal + ' .step-photo.active').id;
        activePhotoId = activePhoto.split('-')[2];
        length = document.querySelector('#' + idVal + ' .step-slides').children.length;
       	if (activePhoto === `photo-step-${length}`){
          	document.querySelector(`#${idVal} #photo-step-1`).className = 'step-photo active';
        	document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).className = 'index-dot';
        	document.querySelector('#' + idVal + ' #' + activePhoto).className = 'step-photo hidden';
          	document.querySelector(`#${idVal} #step-index-1`).className = 'index-dot active';
        } else if (document.querySelector('#' + idVal + ' #' + activePhoto).nextElementSibling.tagName === 'LI'){
          	document.querySelector('#' + idVal + ' #' + activePhoto).nextElementSibling.className = 'step-photo active';
        	document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).className = 'index-dot';
        	document.querySelector('#' + idVal + ' #' + activePhoto).className = 'step-photo hidden';
        	document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).nextElementSibling.className = 'index-dot active';
        }
        if ($(window).width() <= 768) {
        	activeStep = document.querySelector('#' + idVal + ' .step-list.active').id;
            if (activeStep === `step-${length}`){
          		document.querySelector(`#${idVal} #step-1`).className = 'step-list active';
        		document.querySelector('#' + idVal + ' #' + activeStep).className = 'step-list hidden';
            } else if (document.querySelector('#' + idVal + ' #' + activeStep).nextElementSibling.tagName === 'LI'){
          		document.querySelector('#' + idVal + ' #' + activeStep).nextElementSibling.className = 'step-list active';
        		document.querySelector('#' + idVal + ' #' + activeStep).className = 'step-list hidden'
            }
        }
    }
    
    
    
                            
  });
  
  /* ============================================================
       Keydown event for keyboard arrow use
      ============================================================ */
      document.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
          activePhoto = document.querySelector('#' + idVal + ' .step-photo.active').id;
          activePhotoId = activePhoto.split('-')[2];
          length = document.querySelector('#' + idVal + ' .step-slides').children.length;
          if (activePhoto === 'photo-step-1'){
              document.querySelector(`#${idVal} #photo-step-${length}`).className = 'step-photo active';
              document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).className = 'index-dot';
              document.querySelector('#' + idVal + ' #' + activePhoto).className = 'step-photo hidden';
              document.querySelector(`#${idVal} #step-index-${length}`).className = 'index-dot active';
          } else if (document.querySelector('#' + idVal + ' #' + activePhoto).previousElementSibling.tagName === 'LI'){
              document.querySelector('#' + idVal + ' #' + activePhoto).previousElementSibling.className = 'step-photo active';
              document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).className = 'index-dot';
              document.querySelector('#' + idVal + ' #' + activePhoto).className = 'step-photo hidden';
              document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).previousElementSibling.className = 'index-dot active';
          }
        } else if (e.key === 'ArrowRight') {
           activePhoto = document.querySelector('#' + idVal + ' .step-photo.active').id;
           activePhotoId = activePhoto.split('-')[2];
           length = document.querySelector('#' + idVal + ' .step-slides').children.length;
           if (activePhoto === `photo-step-${length}`){
               document.querySelector(`#${idVal} #photo-step-1`).className = 'step-photo active';
               document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).className = 'index-dot';
               document.querySelector('#' + idVal + ' #' + activePhoto).className = 'step-photo hidden';
               document.querySelector(`#${idVal} #step-index-1`).className = 'index-dot active';
           } else if (document.querySelector('#' + idVal + ' #' + activePhoto).nextElementSibling.tagName === 'LI'){
               document.querySelector('#' + idVal + ' #' + activePhoto).nextElementSibling.className = 'step-photo active';
               document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).className = 'index-dot';
               document.querySelector('#' + idVal + ' #' + activePhoto).className = 'step-photo hidden';
               document.querySelector('#' + idVal + ' #step-index-' + activePhotoId).nextElementSibling.className = 'index-dot active';
           }
        } else if (e.key === 'Escape') {
           document.querySelector('#' + idVal).className = 'hidden tutorial_popup';
           document.querySelector('#' + idVal + ' .step-photo.active').className = 'step-photo hidden';
           document.querySelector('#' + idVal + ' .index-dot.active').className = 'index-dot';
        }      
      });
  
  
  
  /* ============================================================
       Touchmove event for touch screen taps
     ============================================================ */  
      document.addEventListener('touchstart', closeTouch);
      document.addEventListener('touchmove', closeTouch);

      function startTouch(e) {
        if (e.targetTouches) {
          if (e.target.className === 'close_popup') {
            document.querySelector('#' + idVal).className = 'hidden tutorial_popup';
            document.querySelector('#' + idVal + ' .step-photo.active').className = 'step-photo hidden';
            document.querySelector('#' + idVal + ' .index-dot.active').className = 'index-dot';
          } else if (
            e.target.className.includes('article_thumbnail')
            || e.target.parentNode.className.includes('article_thumbnail')
            || e.target.parentNode.parentNode.className.includes('article_thumbnail')
            || e.target.parentNode.parentNode.parentNode.className.includes('article_thumbnail')
          ) {
            idVal = e.target.closest('.article_thumbnail').id.split('_')[1];
            document.querySelector('#' + idVal).className = 'tutorial_popup';
            document.querySelector('#' + idVal + ' #photo-step-1').className = 'step-photo active';
            document.querySelector('#' + idVal + ' #step-index-1').className = 'index-dot active';
            if ($(window).width() <= 768) {
              let stepList = document.querySelectorAll('#' + idVal + ' .step-list');
              for (let i = 0; i < stepList.length; i++) {
                stepList[i].className = 'step-list hidden';
              }
              document.querySelector('#' + idVal + ' #step-1').className = 'step-list active';
            }
          } 
        }
      }
  	  function closeTouch(e) {
        if (e.targetTouches) {
          console.log(e.target);
          if (
            e.target.className === 'close_popup'
            || e.target.parentNode.className === 'close_popup'
            || e.target.parentNode.parentNode.className === 'close_popup'
          ) {
            document.querySelector('#' + idVal).className = 'hidden tutorial_popup';
            document.querySelector('#' + idVal + ' .step-photo.active').className = 'step-photo hidden';
            document.querySelector('#' + idVal + ' .index-dot.active').className = 'index-dot';
          }
        }
      }
  
 	 
}

lsTutorialApp();

